export default __webpack_public_path__ + "static/media/custardapple.7320b17b.png";